<svg class="{$$props.class}" viewBox="0 0 512 512">
  <path
    fill="currentColor"
    d="M493.4 24.6l-104-24a24.2 24.2 0 00-27.5 13.9l-48 112a24 24 0 006.9
    28l60.6 49.6a370.6 370.6 0 01-177.2 177.2l-49.6-60.6a24 24 0 00-28-6.9l-112
    48a24.3 24.3 0 00-14 27.6l24 104A24 24 0 0048 512 464 464 0 00512 48a24 24 0
    00-18.6-23.4z" />
</svg>
